
<!-- display top companies contributers -->
<!-- UI  https://lucid.app/lucidchart/80a846c8-f2fd-4a77-bad8-3b3a9693b98f/edit?existing=1&token=f11d6aaea35bd5e87fc270500415170326833ca4-eml%3Dabdelrahman.g%2540ariany.com%26ts%3D1643738227%26uid%3D160359065&docId=80a846c8-f2fd-4a77-bad8-3b3a9693b98f&shared=true&page=u6kPtBC-DqqK#?referringapp=slack -->
<div *ngIf="itemsToShow" class="bg-white container mb-3 mt-lg-5 p-4 slidesContainer">
  <!-- display translated title top companies contributers -->
  <div>
    <h5 class="ranking-header pl-2">{{l("TopCompanyContributors")}}</h5>
  </div>
  <!-- loop to display top companies contributers, each in one row, as image and beside company name -->
  <div *ngIf="itemsToShow" class="m-auto w-100 h-100">
    <div *ngFor="let item of items; let i = index" class="nd-sm-sidebars d-block">

      <div class="single-item row w-100 align-items-center">
        <!-- display top company image  with link to the company page -->
        <div class="col">
          <img class="small-image" [src]="attachmentBaseUrl + '/'  + item?.logoUrl" alt="" [routerLink]="[
          '/app/main/account/view',item.accountId
      ]" onerror="this.src='../../../../../assets/placeholders/ranking-placeholder.png'" />
        </div>
       <!-- display top company name  with link to the company page -->
        <div class="single-item-body col" [ngClass]="true ? '' : 'd-flex flex-row'">
          <div class="text-blue ">
            <a href="javascript:;" [routerLink]="[ '/app/main/account/view',item?.accountId ]">{{item?.accountName}}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="d-sm-sidebars d-none h-100 w-100">
           
      <p-carousel class="hiddenDotsIndicator hiddenIndicator  slidersContainerCarousel  h-100 w-100" [numVisible]="1.5"
    [value]="items"  [circular]="false">
      <ng-template let-item pTemplate="item">
        <div 
        [ngClass]="items.length >1 ? 'slide-md-Section' : 'slide-sm-Section'" >
                  <!-- display top company image  with link to the company page -->
                 
                    <img  [ngClass]="items.length >1 ? 'slide-medium-image' : 'slide-small-image'" 
                    [src]="attachmentBaseUrl + '/'  + item?.logoUrl" alt="" [routerLink]="[
                    '/app/main/account/view',item.accountId
                ]" onerror="this.src='../../../../../assets/placeholders/Topcompanycontributers.png'" />

                
                  <!-- display top company name  with link to the company page -->
                  <div class="slide-single-item-body pt-3">
                      <h5>
                        <a class="text-white" href="javascript:;" [routerLink]="[ '/app/main/account/view',item?.accountId ]">{{item?.accountName}}</a>
                    </h5>
                  </div>
              </div>
          </ng-template>
      </p-carousel>
  </div>

  </div> 
<div *ngIf="!itemsToShow" class="bg-white container mb-3 mt-lg-5 p-4 slidesContainer noslidedata">
    
  <img class="small-image" src="" alt=""
       
      onerror="this.src='../../../../../assets/placeholders/TopCompanyContributors-placeholder.jpg'" />

</div>